import localforage from "localforage";

// 初始化 localforage 实例
const boardStorage = localforage.createInstance({
  name: "holopix-board-data",
  storeName: "snapshots"
});
/**
 * 画板快照画布数据
 * 继承自 FabricCanvasData，添加了视口信息用于本地恢复
 */
export interface BoardSnapshotCanvasData {
  viewport: {
    zoom: number;
    pan: {
      x: number;
      y: number;
    };
    center?: {
      top: number;
      left: number;
    };
  };
  /** 画板 ID */
  id?: number;
  /** 图层对象列表 */
  objects: any[];
  /** fabric 版本号 */
  version: string;
}
export interface BoardSnapshot {
  boardId: number;
  canvasData: BoardSnapshotCanvasData;
  timestamp: number;
  thumbnail?: string; // 可选：封面缩略图 base64
}

/**
 * 保存画板快照到本地
 */
export const saveBoardSnapshot = async (boardId: number, snapshot: Omit<BoardSnapshot, "timestamp">) => {
  try {
    const data: BoardSnapshot = {
      ...snapshot,
      timestamp: Date.now()
    };
    await boardStorage.setItem(String(boardId), data);
    return true;
  } catch (error) {
    console.error("[Storage] Failed to save snapshot:", error);
    return false;
  }
};

/**
 * 获取本地画板快照
 */
export const getBoardSnapshot = async (boardId: number): Promise<BoardSnapshot | null> => {
  try {
    return await boardStorage.getItem<BoardSnapshot>(String(boardId));
  } catch (error) {
    console.error("[Storage] Failed to get snapshot:", error);
    return null;
  }
};

/**
 * 删除本地画板快照
 */
export const removeBoardSnapshot = async (boardId: number) => {
  try {
    await boardStorage.removeItem(String(boardId));
  } catch (error) {
    console.error("[Storage] Failed to remove snapshot:", error);
  }
};

/** 清空当前浏览器中的所有画布快照。 */
export const clearBoardSnapshots = async () => {
  await boardStorage.clear();
};

/**
 * 清理过期的快照 (可选，例如清理超过7天的)
 */
export const clearExpiredSnapshots = async (days: number = 7) => {
  try {
    const keys = await boardStorage.keys();
    const now = Date.now();
    const expireTime = days * 24 * 60 * 60 * 1000;

    for (const key of keys) {
      const item = await boardStorage.getItem<BoardSnapshot>(key);
      if (item && now - item.timestamp > expireTime) {
        await boardStorage.removeItem(key);
      }
    }
  } catch (error) {
    console.error("[Storage] Failed to clear expired snapshots:", error);
  }
};
